import {fetchAndParse, FetchResult} from './Common';
import {DocsRoute, MDX_PATH} from '../pages/Pages';
import {API_NAMES, apiRoute} from '../api/Common';

export interface DocumentPageOptions {
	route: DocsRoute;
}
const EXCLUDED: Set<DocsRoute | string> = new Set([DocsRoute.ASSETS_FILES, ...API_NAMES.map(apiRoute)]);

export class DocumentPageClass {
	private static _instance: DocumentPageClass;
	static instance() {
		return (this._instance = this._instance || new DocumentPageClass());
	}
	private constructor() {}

	private _resultByUrl: Map<string, FetchResult> = new Map();
	url(options: DocumentPageOptions) {
		const templateName = MDX_PATH[options.route] || options.route;
		return `/editor/docs/pages/mdx/${templateName}.mdx`;
	}

	async fetch(options: DocumentPageOptions): Promise<FetchResult | undefined> {
		if (EXCLUDED.has(options.route)) {
			return;
		}
		const url = this.url(options);
		let result = this._resultByUrl.get(url);
		if (!result) {
			result = await fetchAndParse(url);
		}
		return result;
	}
}

export const DocumentPage = DocumentPageClass.instance();
